/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiLeadFromJSON, ApiLeadToJSON, } from './ApiLead';
import { ApiLeadInteractionFromJSON, ApiLeadInteractionToJSON, } from './ApiLeadInteraction';
import { ApiLeadStatusRuleFromJSON, ApiLeadStatusRuleToJSON, } from './ApiLeadStatusRule';
export function ApiLeadStatusFromJSON(json) {
    return ApiLeadStatusFromJSONTyped(json, false);
}
export function ApiLeadStatusFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'interactions': !exists(json, 'interactions') ? undefined : (json['interactions'].map(ApiLeadInteractionFromJSON)),
        'lead': !exists(json, 'lead') ? undefined : ApiLeadFromJSON(json['lead']),
        'leadId': !exists(json, 'leadId') ? undefined : json['leadId'],
        'leadStatusRule': !exists(json, 'leadStatusRule') ? undefined : ApiLeadStatusRuleFromJSON(json['leadStatusRule']),
        'leadStatusRuleId': !exists(json, 'leadStatusRuleId') ? undefined : json['leadStatusRuleId'],
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
    };
}
export function ApiLeadStatusToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'id': value.id,
        'interactions': value.interactions === undefined ? undefined : (value.interactions.map(ApiLeadInteractionToJSON)),
        'lead': ApiLeadToJSON(value.lead),
        'leadId': value.leadId,
        'leadStatusRule': ApiLeadStatusRuleToJSON(value.leadStatusRule),
        'leadStatusRuleId': value.leadStatusRuleId,
        'projectId': value.projectId,
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
    };
}
